// imports section Start
import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import RoomServiceIcon from "@mui/icons-material/RoomService";
import { useStyles } from "../../../assets/styles/Theme";
import { Card, Grid, Typography, Button, IconButton } from "@mui/material";
import { formatDate, formatTime } from "../../../utils/common/DateFormat";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import { currencyFormat } from "../../../utils/common/CurrencyFormat";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// imports section End

const PlacedOrderItemCard = ({
  placedorderItem,
  onViewOrder,
  order,
  details,
  billDetails,
  setLoading,
  loading,
}) => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Hooks end

  // Handlers start
  const formattedDate = formatDate(placedorderItem.ORDERENDATE);
  const formattedTime = formatTime(placedorderItem.ORDERTIME);
  const formattedAmount = currencyFormat(
    placedorderItem.AMOUNT,
    placedorderItem.PREFCURRENCY
  );
  const handlePayClick = async () => {
    if (loading) return; // Prevent the function from running if it's already loading
    setLoading(true); // Set loading state to true, disabling UI interactions

    try {
      // Await the order details to load first
      await onViewOrder(placedorderItem); // Wait for the details to be fetched
      // await new Promise((resolve) => setTimeout(resolve, 15000));
      // Now navigate after data is loaded
      if (true) {
        navigate("/Cashier", {
          state: {
            // placedOrderDetails: details.items,
            // billDetails: billDetails.items[0],
            ordercode: placedorderItem.ORDERCODE,
          },
        });
      } else {
        console.error("Order or Bill Details are missing");
      }
    } catch (error) {
      console.error("Error loading data: ", error);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  // Handlers end

  return (
    <Card sx={styles.po_card}>
      <Grid
        sx={{
          borderLeft: `4px solid #28B411`,
          paddingLeft: "8px",
        }}
      >
        <Grid sx={styles.po_card_content}>
          <Typography sx={styles.po_card_texts}>
            #{placedorderItem.INVNO}
          </Typography>
          <Typography
            sx={{
              //   ...styles.po_card_id,
              color: theme.palette.input_field.text,
              fontSize: "14px",
              fontWeight: 600,
              lineHeight: "130%",
            }}
          >
            {formattedAmount}
          </Typography>
        </Grid>
        <Grid
          sx={{
            ...styles.po_card_content,
          }}
        >
          <Typography
            sx={{
              ...styles.po_card_texts,
              fontSize: "14px",
              fontWeight: 600,
              lineHeight: "130%",
            }}
          >
            {placedorderItem.ORDERTYPE}
          </Typography>
          <Typography
            sx={{
              ...styles.po_card_texts,
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: "130%",
            }}
          >
            {placedorderItem.STSTXT}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        sx={{
          ...styles.po_card_content,
          borderTop: `1px solid ${theme.palette.stroke.main}`,
          //   borderRadius: 0,
          pt: 2,
          mt: 1,
        }}
      >
        <Grid sx={styles.po_card_grid}>
          <Typography sx={styles.po_card_text_numbers}>
            <IconButton sx={styles.po_card_icons}>
              <CalendarMonthIcon />
            </IconButton>
            {formattedDate}
          </Typography>
          <Typography sx={styles.po_card_text_numbers}>
            <IconButton sx={styles.po_card_icons}>
              <AccessTimeFilledIcon />
            </IconButton>
            {formattedTime}
          </Typography>
          <Typography
            sx={{
              ...styles.po_card_text_numbers,
              color: theme.palette.input_field.text,
            }}
          >
            <IconButton sx={styles.po_card_icons}>
              <RoomServiceIcon />
            </IconButton>
            {placedorderItem.WAITER}
          </Typography>
        </Grid>
        <Grid sx={styles.po_card_grid}>
          <Button
            sx={styles.btn_secondary}
            size="medium"
            variant="outlined"
            // onClick={() => onViewOrder(placedorderItem)}
            onClick={() => onViewOrder(placedorderItem)}
          >
            View
          </Button>
          <Button
            sx={styles.btn_primary}
            size="medium"
            variant="contained"
            onClick={handlePayClick}
            disabled={loading}
          >
            Pay Now
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

export default PlacedOrderItemCard;
